import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { SearchFlowsState } from '../models/flows.model';
import * as selectors from '../selectors/search-flows.selectors';

@Injectable({ providedIn: 'root' })
export class SearchFlowsFacadeService extends FacadeService {
  constructor(public override store: Store<SearchFlowsState>) {
    super(store);
  }

  // OBSERVABLES
  templateProperties$ = this.storeSelect(selectors.getTemplateProperties);
  panelExpanded$ = this.storeSelect(selectors.getPanelExpansion);
  flowName$ = this.storeSelect(selectors.getFlowName);
  flowContextValues$ = this.storeSelect(selectors.getContextValues);
  flowContext$ = this.storeSelect(selectors.getContext);
  activeFlows$ = this.storeSelect(selectors.getActiveFlows);
  deactivatedFlows$ = this.storeSelect(selectors.getDeactivatedFlows);
  searchButtonDisabled$ = this.storeSelect(selectors.getSearchRole);
  createNewButtonDisabled$ = this.storeSelect(selectors.getCreateNewRole);
  updateRole$ = this.storeSelect(selectors.getUpdateRole);
  updateAdvancedRole$ = this.storeSelect(selectors.getUpdateAdvancedRole);

  // OBSERVABLE'S VALUES
  get templateProperties() {
    return this.storeSnapshot(this.templateProperties$);
  }

  get panelExpanded() {
    return this.storeSnapshot(this.panelExpanded$);
  }

  get flowName() {
    return this.storeSnapshot(this.flowName$);
  }

  get flowContext() {
    return this.storeSnapshot(this.flowContext$);
  }

  get activeFlows() {
    return this.storeSnapshot(this.activeFlows$);
  }

  get deactivatedFlows() {
    return this.storeSnapshot(this.deactivatedFlows$);
  }
}
